import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Mode } from '@thirdweb-dev/chains';
import { getContract } from '@thirdweb-dev/react';
import nftMarketplaceAbi from 'abis/NFTMarketPlace.json';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

async function fetcher(
  listingId: string,
  config: ApplicationConfig | undefined
) {
  if (!config) {
    return null;
  }

  try {
    const contract = await getContract({
      address: config.CONTRACTS.NFT_MARKETPLACE,
      network: Mode,
      contractTypeOrAbi: nftMarketplaceAbi
    });

    // @ts-ignore
    const res = await contract.call('getCurrentItemPriceAtDutchAuction', [
      listingId
    ]);

    return res;
  } catch (e) {
    console.error(e);

    return false;
  }
}

export function useGetCurrentPriceForDutchAuction(listingId: string) {
  const config = useConfig();

  return useQuery(
    [QueryKeys.GET_CURRENT_PRICE_FOR_DUTCH_AUCTION, listingId, !!config],
    () => fetcher(listingId, config),
    {
      enabled: Boolean(config)
    }
  );
}
